'use client';

import { Typography } from '@musinsa/mds';
import { useRemoveCommonLayout } from '@musinsa/mds-ui';
import { SERVICE, type ServiceType } from '@musinsa/packages-device-detection';
import Image from 'next/image';
import { getCdnUrl } from '../common/utils';
import { formatMaintenanceWindow, type MaintenanceWindow } from './utils/formatMaintenanceWindow';

interface MaintenancePageProps {
  className?: string;
  service?: ServiceType;
  window?: MaintenanceWindow;
}

const MUSINSA_LOGO_SRC = 'https://image.msscdn.net/static/assets/bi/error_logo_musinsa.png';

export function MaintenancePage({ className, service, window }: MaintenancePageProps) {
  useRemoveCommonLayout({ removeAppBar: true, removeFooter: true });

  const isMusinsa = service === SERVICE.MUSINSA;
  const logo = isMusinsa ? (
    <Image src={MUSINSA_LOGO_SRC} alt="무신사 로고" width={100} height={17} />
  ) : (
    <Image src={getCdnUrl('/images/logo/29-logo.png')} alt="29cm 로고" width={60} height={16} />
  );

  const formattedWindow = window ? formatMaintenanceWindow(window) : null;

  return (
    <div
      className={`flex min-h-screen w-full flex-col items-center justify-center bg-white px-[40px] ${className ?? ''}`}
    >
      <div className="flex items-center justify-center pb-[12px]">
        <div className="flex size-[48px] items-center justify-center">{logo}</div>
      </div>

      <div className="flex w-full flex-col items-center gap-[8px] text-center">
        <Typography variant="body14pxSemi" colorScheme="black">
          서비스 점검 중이에요.
        </Typography>
        <Typography variant="body13pxReg" colorScheme="gray-600">
          더 빠르고 안정적인 서비스 제공을 위해
          <br />
          시스템 점검을 진행하고 있어요.
        </Typography>
        <Typography variant="body13pxReg" colorScheme="gray-600">
          점검 시간 동안 서비스 이용이 일시 중단되며
          <br />
          작업 상황에 따라 종료가 길어질 수 있어요.
        </Typography>
      </div>

      {formattedWindow && (
        <div className="flex flex-col items-center pt-[20px]">
          <Typography variant="body12pxReg" colorScheme="gray-600">
            점검 일시 : {formattedWindow}
          </Typography>
        </div>
      )}
    </div>
  );
}
